(function () {
  var overlay = document.getElementById('PppQuickAddModal');
  var closeBtn = overlay ? overlay.querySelector('[data-ppp-qa-close]') : null;
  var img = document.getElementById('PppQaImage');
  var titleEl = document.getElementById('PppQaTitle');
  var priceEl = document.getElementById('PppQaPrice');
  var optionsEl = document.getElementById('PppQaOptions');
  var errorEl = document.getElementById('PppQaError');
  var confirmBtn = document.getElementById('PppQaConfirmBtn');

  var currentProduct = null;
  var selectedVariantId = null;
  var activeTrigger = null;

  if (!overlay) return;

  function money(cents) {
    return (cents / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  }

  function findVariant(options) {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === options[i]; });
    }) || null;
  }

  function renderOptions() {
    optionsEl.innerHTML = '';
    if (currentProduct.options.length === 1 && currentProduct.options[0].toLowerCase() === 'title') {
      selectedVariantId = currentProduct.variants[0].id;
      confirmBtn.disabled = !currentProduct.variants[0].available;
      return;
    }

    currentProduct.options.forEach(function (optionName, optionIndex) {
      var group = document.createElement('div');
      group.className = 'ppp-qa-option-group';

      var label = document.createElement('div');
      label.className = 'ppp-qa-option-label';
      label.textContent = optionName;
      group.appendChild(label);

      var valuesWrap = document.createElement('div');
      valuesWrap.className = 'ppp-qa-option-values';

      var seen = {};
      currentProduct.variants.forEach(function (v) {
        var val = v.options[optionIndex];
        if (seen[val]) return;
        seen[val] = true;

        var isAvailable = currentProduct.variants.some(function (vv) {
          return vv.options[optionIndex] === val && vv.available;
        });

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ppp-qa-option-btn' + (isAvailable ? '' : ' is-disabled');
        btn.textContent = val;
        btn.disabled = !isAvailable;
        btn.dataset.optionIndex = optionIndex;
        btn.dataset.value = val;

        btn.addEventListener('click', function () {
          valuesWrap.querySelectorAll('.ppp-qa-option-btn').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          checkSelectionComplete();
        });

        valuesWrap.appendChild(btn);
      });

      group.appendChild(valuesWrap);
      optionsEl.appendChild(group);
    });
  }

  function checkSelectionComplete() {
    var groups = optionsEl.querySelectorAll('.ppp-qa-option-group');
    var selected = [];
    var complete = true;

    groups.forEach(function (group) {
      var sel = group.querySelector('.ppp-qa-option-btn.is-selected');
      if (!sel) { complete = false; return; }
      selected[parseInt(sel.dataset.optionIndex, 10)] = sel.dataset.value;
    });

    if (!complete) {
      confirmBtn.disabled = true;
      selectedVariantId = null;
      return;
    }

    var variant = findVariant(selected);
    if (variant && variant.available) {
      selectedVariantId = variant.id;
      confirmBtn.disabled = false;
      priceEl.textContent = money(variant.price);
    } else {
      selectedVariantId = null;
      confirmBtn.disabled = true;
      showError('That combination is out of stock.');
    }
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function hideError() {
    errorEl.hidden = true;
  }

  function openModal(handle, trigger) {
    activeTrigger = trigger;
    hideError();
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Add to Bag';
    optionsEl.innerHTML = '';
    titleEl.textContent = 'Loading…';
    priceEl.textContent = '';
    img.src = '';

    overlay.hidden = false;
    document.body.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product fetch failed');
        return res.json();
      })
      .then(function (product) {
        currentProduct = product;
        titleEl.textContent = product.title;
        priceEl.textContent = money(product.price);
        img.src = product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        img.alt = product.title;
        renderOptions();
      })
      .catch(function () {
        titleEl.textContent = 'Something went wrong';
        showError('Could not load this product. Please try again.');
      });
  }

  function closeModal() {
    overlay.hidden = true;
    document.body.style.overflow = '';
    currentProduct = null;
    selectedVariantId = null;
    activeTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ppp-qa-close]');
    if (trigger) closeModal();
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeModal();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ppp-qa-trigger]');
    if (!trigger) return;
    e.preventDefault();
    openModal(trigger.dataset.productHandle, trigger);
  });

  confirmBtn.addEventListener('click', function () {
    if (!selectedVariantId) return;
    hideError();
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Adding…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Add to cart failed'); });
        return res.json();
      })
      .then(function () {
        confirmBtn.textContent = 'Added ✓';
        // Refresh Dawn's cart drawer/notification using its native re-render
        return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart-notification-product,cart-notification-button');
      })
      .then(function (res) { return res && res.json ? res.json() : null; })
      .then(function (sections) {
        if (sections) {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { detail: { sections: sections } })
          );
          // Trigger Dawn's existing cart update event so drawer/notification opens itself
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        }
        // Dawn listens for this on the PUB_SUB_EVENTS.cartUpdate channel;
        // simplest reliable trigger is firing a native change on the theme's cart icon
        var cartIcon = document.querySelector('#cart-icon-bubble, .cart-icon-bubble');
        if (cartIcon) cartIcon.dispatchEvent(new Event('click', { bubbles: true }));
        setTimeout(closeModal, 500);
      })
      .catch(function (err) {
        confirmBtn.textContent = 'Add to Bag';
        confirmBtn.disabled = false;
        showError(err.message || 'Could not add to cart. Please try again.');
      });
  });
})();